import React, { useState } from 'react';
import api from '../api/axios';

const UploadCSVModal = ({ isOpen, onClose, onUploadSuccess }) => {
    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [response, setResponse] = useState(null);

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleUpload = async () => {
        if (!file) {
            alert("Please select a file.");
            return;
        }
        setUploading(true);
        setResponse(null);

        const formData = new FormData();
        formData.append('file', file);

        try {
            const res = await api.post('/crm/business/upload_csv', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            setResponse(res.data);
            onUploadSuccess(); // Refresh the list in the parent component
        } catch (error) {
            setResponse({ message: "Upload failed.", errors: [error.response?.data?.message || 'Server error'] });
            console.error("Upload failed", error);
        } finally {
            setUploading(false);
        }
    };

    const handleClose = () => {
        setFile(null);
        setResponse(null);
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-lg">
                <h3 className="text-lg font-medium leading-6 text-gray-900">Upload Business Leads via CSV</h3>
                <div className="mt-4">
                    <input type="file" accept=".csv" onChange={handleFileChange} className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-orange-50 file:text-orange-700 hover:file:bg-orange-100"/>
                    <p className="text-xs text-gray-500 mt-2">CSV must contain 'name' and 'subdomain' columns.</p>
                </div>
                {response && (
                    <div className="mt-4 p-4 bg-gray-50 rounded-md">
                        <p className="font-semibold">{response.message}</p>
                        {response.errors && response.errors.length > 0 && (
                            <ul className="list-disc list-inside text-sm text-red-600 mt-2">
                                {response.errors.map((err, i) => <li key={i}>{err}</li>)}
                            </ul>
                        )}
                    </div>
                )}
                <div className="mt-6 flex justify-end gap-4">
                    <button onClick={handleClose} type="button" className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50">Close</button>
                    <button onClick={handleUpload} disabled={uploading} type="button" className="px-4 py-2 text-sm font-medium text-white bg-green-600 border border-transparent rounded-md hover:bg-green-700 disabled:bg-gray-400">
                        {uploading ? 'Uploading...' : 'Upload File'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UploadCSVModal;